export { ContractsComponent } from "./contracts.component";
export { ContractsModule } from "./contracts.module";
//export { AssetsRoutingModule } from "./assets-routing.module";
